export enum AnimationType {
  FADE = 'fade',
  SLIDE = 'slide',
  EXPAND = 'expand'
}
